<template>
  <div :class="componentClasses">
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  spacing: {
    type: String,
    default: '',
  },
});

const componentClasses = computed(() => [
  'stk-menu',
  props.spacing && `spacing-${props.spacing}`,
]);
</script>

<style>
.stk-menu {
  align-items: stretch;
  display: flex;
  flex-direction: column;
  gap: 0.5em;

  &.spacing-tight {
    gap: 0;

    .stk-menu-item {
      padding: 0.375em;
    }
  }
}
</style>
